/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "semantic-ui-react";
import { Ico } from "../../Icon/Icon";
import cStyles from "./../../Components.module.css";

interface ReportParamsProps {
  startDate: Date;
  setStartDate: any;
  endDate: Date;
  setEndDate: any;
  loading: boolean;
  generateReport: any;
  title?: string;
}

const ReportParams: React.FC<ReportParamsProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  loading,
  generateReport,
  title,
}) => {
  const dateOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const generateForFixedTimeRange = (pastDays: number) => {
    const fixedEndDate = new Date();
    const fixedStartDate = new Date(
      fixedEndDate.getTime() - 1000 * 3600 * 24 * pastDays
    );
    fixedStartDate.setHours(0);
    fixedStartDate.setMinutes(0);
    setStartDate(fixedStartDate);
    setEndDate(fixedEndDate);
    generateReport(fixedStartDate, fixedEndDate);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <span style={{ marginRight: "1rem" }}>Start Date</span>
      <DatePicker
        selected={startDate}
        onChange={(date: Date) => {
          setStartDate(date);
        }}
        customInput={
          <Button secondary className={cStyles.buttonSecond}>
            {startDate.toLocaleDateString(
              navigator.language,
              dateOptions as any
            )}
          </Button>
        }
      />

      <span style={{ marginLeft: "2rem", marginRight: "1rem" }}>End Date</span>

      <DatePicker
        selected={endDate}
        onChange={(date: Date) => {
          setEndDate(date);
        }}
        customInput={
          <Button secondary className={cStyles.buttonSecond}>
            {endDate.toLocaleDateString(navigator.language, dateOptions as any)}
          </Button>
        }
      />

      <Button
        primary
        className={cStyles.buttonPrime}
        loading={loading}
        disabled={loading}
        onClick={() => generateReport()}
        style={{ marginLeft: "2rem" }}
      >
        <Ico name="search" style={{ marginRight: "10px" }} />
        {title || "Search"}
      </Button>

      <span
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          gap: "1rem",
        }}
      >
        <Button.Group>
          <Button
            primary
            className={cStyles.buttonPrime}
            disabled={loading}
            onClick={() => generateForFixedTimeRange(1)}
          >
            Last 24 Hours
          </Button>

          <Button
            primary
            className={cStyles.buttonPrime}
            disabled={loading}
            onClick={() => generateForFixedTimeRange(7)}
          >
            Last 7 Days
          </Button>

          <Button
            primary
            className={cStyles.buttonPrime}
            disabled={loading}
            onClick={() => generateForFixedTimeRange(30)}
          >
            Last 30 Days
          </Button>
        </Button.Group>
      </span>
    </div>
  );
};

export default ReportParams;
